import type { z } from "@hono/zod-openapi";
import { onDriverRefs, onVehicleRefs } from "../../refs";

/**
 * The driver whose log changed, on the unit the event names — both always present.
 *
 * The co-driver is deliberately absent. Seat changes are transitions and belong to the assignment stream's
 * `VehicleDriverAssignmentTransition`; a duty-status event states one driver's log and nothing about who rode along.
 */
export const dutyStatusChangeRefs = { ...onDriverRefs, ...onVehicleRefs };

export type DutyStatusChangeRefs = z.infer<z.ZodObject<typeof dutyStatusChangeRefs>>;
